import { Link } from "react-router";

export const sections = [
  {
    id: "definitions",
    title: "Definitions",
    content: (
      <ul className="ul-list">
        <li>
          "<span className="text-co-text">Company</span>" or "
          <span className="text-co-text">Mo7tawa</span>":{" "}
          <span className="text-co-text">Mohtawa L.L.C-FZ</span>,
          a private company limited by shares incorporated in Meydan, U.A.E,
          with a registration number 2204175.01, the owner and operator of the
          platform.
        </li>
        <li>
          "<span className="text-co-text">Platform</span>":
          Mo7tawa website and associated services.
        </li>
        <li>
          "<span className="text-co-text">User</span>": Any
          individual or entity that accesses or uses the Platform.
        </li>
        <li>
          "<span className="text-co-text">Content</span>": All
          content creatives-generated media assets, including images, videos,
          audio, and other digital files, shared on the Platform.
        </li>
        <li>
          "<span className="text-co-text">Content Creative</span>
          ": means the user who uploads content on the Platform.
        </li>
        <li>
          "
          <span className="text-co-text">
            Content Creative Channels
          </span>
          ": means the Platform and channels which are controlled by the Content
          Creative and in relation to which the Content Creative agrees to
          distribute the Content Creative Materials.
        </li>
        <li>
          "
          <span className="text-co-text">
            Content Creative Materials
          </span>
          ": means any and all content and materials produced by or on behalf of
          the Content Creative (including the copy (including social media
          posts), blog, vlog, audio visual recording, sound recording, Augmented
          reality filters, Spatial design templates, 3D objects, Graphic Design
          elements (Vectors), Video, photograph or image.
        </li>
      </ul>
    ),
  },
  {
    id: "account-registration",
    title: "Account Registration",
    content: (
      <ul className="ul-list">
        <li>
          To access certain features of the Platform, you must create an
          account. You are responsible for maintaining the confidentiality of
          your account information and for all activities that occur under your
          account.
        </li>
        <li>
          You agree to provide accurate and up-to-date information when
          registering for an account.
        </li>
        <li>
          The Company may ask you for additional details for verification
          purposes for onboarding purposes (such as national ID document,
          passport copy, bank account details etc.) without which your
          membership on the Platform may be limited or terminated.
        </li>
        <li>
          The Company reserves the right to terminate accounts for any reason,
          including violations of these Terms.
        </li>
      </ul>
    ),
  },
  {
    id: "content-submission",
    title: "Content Submission and Licensing",
    content: (
      <ul className="ul-list">
        <li>
          By uploading content to the Platform, you grant the Company a
          non-exclusive, worldwide license to use, display, distribute, sell and
          modify your Content for the operation and promotion of the Platform at
          a price fixed by the Company as well to train LLM models for the
          purpose of creating an ethical Gen-AI model.
        </li>
        <li>
          You shall submit all Content Creative Materials to the Company for
          prior approval and the Parties agree that the Company shall have final
          editorial control over the Content Creative Materials.
        </li>
        <li>
          Any acceptance of the Content Creative Materials remain at the sole
          discretion of the Company.
        </li>
        <li>
          You shall not publicly release and/or make available any Content
          Creative Materials which have not been approved by the Company in
          accordance with clause 6.3.
        </li>
        <li>
          At any time upon written request, the Content Creative shall promptly
          remove and delete: all Content Creative Materials posted by or on
          behalf of the Content Creative from any or all Content Creative
          Channels (as applicable); and all references to and associations with
          the Company on the Content Creative Channels or elsewhere.
        </li>
        <li>
          You retain ownership of your Content but grant other users a limited
          license to use your content in accordance with the Platform&#39;s
          terms.
        </li>
        <li>
          You are responsible for ensuring that you have the rights to upload
          and license the content you submit.
        </li>
        <li>
          You agree that the Company may use and reproduce (and authorize others
          to do so) reproductions of the Content Creative Materials.
        </li>
      </ul>
    ),
  },
  {
    id: "third-party-services",
    title: "Third Party Services & Content",
    content: (
      <>
        The Platform may contain advertisements or links to third parties’
        websites. The services may be made available or accessed in connection
        with third party services providers and content (including advertising)
        that the Company does not control. You acknowledge and agree to their
        terms and conditions or terms of use and privacy policies or any other
        policies or cookies that may apply to your use of such third-party
        services and content that might differ from these Terms. The Company
        will not be responsible or liable for any products or services of such
        third-party service providers, for any acts or omissions of any
        advertiser, etc. Such third-party service providers shall be solely and
        fully responsible for their third-party services or products provided
        through the Platform.
        <br />
        <br />
        Additionally, Apple Inc., Google, Inc. or Microsoft Corporation are
        third-party beneficiaries. If you access the Platform using applications
        developed for Apple iOS, Android or Microsoft Windows mobile devices,
        respectively by these third parties’ beneficiaries, you must abide by
        their terms as set forth in the terms of use/service of their
        applications. These third-party beneficiaries are not parties to these
        Terms and are not responsible for the provision or support of the
        services in any manner. Your access to our services using these devices
        is subject to terms set forth in the applicable third-party
        beneficiary’s terms of use/service. You agree to comply with any
        applicable third-party terms when using our Services.
      </>
    ),
  },
  {
    id: "creator-responsibilities",
    title: "Content Creative Responsibilities",
    content: (
      <ul className="ul-list">
        <li>
          You must comply with all applicable laws and regulations when using
          the Platform.
        </li>
        <li>
          You agree not to upload the Content Creative Materials that are
          illegal, defamatory, obscene, violates the rights of others or is in
          breach of the applicable laws, notably the media and content laws in
          the United Arab Emirates and any other jurisdiction the Company
          operates in.
        </li>
        <li>
          You agree to respect the intellectual property rights of other users
          and the Company.
        </li>
      </ul>
    ),
  },
  {
    id: "monetization-payments",
    title: "Monetization and Payments",
    content: (
      <ul className="ul-list">
        <li>
          The Platform may offer monetization opportunities, such as paid
          content, subscriptions, or advertising revenue sharing.
        </li>
        <li>
          Payments for monetization will be made according to the Company's
          payment policies and schedules.
        </li>
        <li>
          The Company is not responsible for any taxes or financial obligations
          arising from your use of the Platform.
        </li>
      </ul>
    ),
  },
  {
    id: "prohibited-uses",
    title: "Prohibited Uses",
    content: (
      <ul className="ul-list">
        <li>
          You may not use the Platform to engage in illegal activity or to
          violate the rights of others or applicable laws.
        </li>
        <li>
          You may not upload content that contains viruses, malware, other
          harmful software or violates platform security.
        </li>
        <li>
          You may not impersonate other users, create fake accounts or use the
          Platform to harass others.
        </li>
      </ul>
    ),
  },
  {
    id: "intellectual-property",
    title: "Intellectual Property",
    content: (
      <ul className="ul-list">
        <li>
          The Platform and all content owned by the Company are protected by
          copyright and other intellectual property laws.
        </li>
        <li>
          You do not acquire ownership rights in the Platform or the Company's
          content by using the Platform.
        </li>
        <li>
          You agree not to infringe on the intellectual property rights of
          others.
        </li>
      </ul>
    ),
  },
  {
    id: "termination",
    title: "Termination",
    content: (
      <ul className="ul-list">
        <li>
          The Company may terminate or suspend your account at any time, with or
          without notice, for any reason, including violations of these Terms.
        </li>
        <li>
          Upon termination, you must cease all use of the Platform and comply
          with any other termination requirements specified by the Company.
        </li>
      </ul>
    ),
  },
  {
    id: "disclaimers-liability",
    title: "Disclaimers and Limitations of Liability",
    content: (
      <>
        The Company will not be liable for damages or losses arising from your
        use or inability to use the Platform, or otherwise arising under these
        Terms. Please read this section carefully as it limits our obligations
        and liability towards you.
        <br />
        <br />
        <p className="font-semibold text-co-text">Disclaimer</p>
        You will use the Platform at your own risk. The Platform is provided on
        an “as is” and “as available” basis. The Company disclaims all
        representations and warranties, express, implied, or statutory, not
        expressly set out in these Terms, including the implied warranties of
        merchantability, fitness for a particular purpose and non-infringement.
        In addition, the Company makes no representation, warranty, or guarantee
        regarding the reliability, timeliness, quality, suitability, or
        availability of the Platform or any services or goods requested through
        the use of the Platform, or that the Platform will be uninterrupted or
        error-free.
        <br />
        You agree that the entire risk arising out of your use of the Platform,
        and any service or good requested in connection therewith, remains
        solely with you, to the maximum extent permitted under applicable law in
        the country where the Services are provided.
        <br />
        <br />
        <p className="font-semibold text-co-text">
          Limitation of Liability
        </p>
        The Company shall not be liable for indirect, incidental, special,
        exemplary, punitive, or consequential damages, including lost profits,
        lost data, personal injury, or property damage related to, in connection
        with, or otherwise resulting from any use of the Platform, even if the
        Company has been advised of the possibility of such damages. The Company
        shall not be liable for any damages, liability or losses arising out of
        your use of or reliance on the Platform or your inability to access or
        use the Platform. The Company shall not be liable for delay, failure in
        performance, or other injuries resulting from causes beyond the
        Company’s reasonable control.
        <br />
        <br />
        Furthermore, the Company is not liable for any other intangible losses
        resulting from:
        <ul className="ul-list">
          <li>
            The use of or reliance on the Platform or your inability to use the
            Platform;
          </li>
          <li>Unauthorized access to or alteration of your account or data;</li>
          <li>Statements or conduct of any third party on the Platform; or</li>
          <li>Any other matter relating to the Platform.</li>
        </ul>
        <br />
        The Company also assumes no liability or responsibility for a delay,
        failure in performance, any bugs, viruses, Trojan horses or the like
        that be transmitted to or through the Platform by any third party and/or
        any user content or the defamatory, offensive, or illegal conduct of any
        third party, or any other injury resulting from causes beyond the
        Company’s reasonable control. The limitations and disclaimer in this
        section do not purport to limit liability or alter your rights as a
        consumer that cannot be excluded under applicable law.
      </>
    ),
  },
  {
    id: "indemnification",
    title: "Indemnification",
    content: (
      <>
        You are responsible for your use of the Platform, and you will indemnify
        and hold the Company and its officers, directors, employees,
        consultants, affiliates, subsidiaries, and agents (together “Company
        Entities”) from and against any and all claims, demands, losses,
        liabilities, and expenses (including attorneys’ fees), arising out of or
        in any way connected with:
        <ul className="ul-list">
          <li>your access to, use of, or alleged use of, the Platform;</li>
          <li>
            your breach or violation of any of these terms and conditions of
            these Terms, any representation, warranty, or agreement referenced
            in these Terms, or any applicable law or regulation;
          </li>
          <li>Company’s use of your content;</li>
          <li>
            your violation of the rights of any third party, including but not
            limited to any intellectual property right or publicity,
            confidentiality, other property, or privacy, right; or
          </li>
          <li>any dispute or issue between you and any third party.</li>
        </ul>
        <br />
        The Company reserves the right, at our own expense, to assume the
        exclusive defence and control of any matter otherwise subject to
        indemnification by you (without limiting your indemnification
        obligations with respect to that matter), and in that case, you agree to
        cooperate with our defence of that claim.
      </>
    ),
  },
  {
    id: "data-privacy",
    title: "Data Privacy and Security",
    content: (
      <>
        You hereby consent to the collection and/or processing of your personal
        data by the Company. The Company is committed to protecting the personal
        data that the Company receives from you, or otherwise processes
        according to the{" "}
        <Link to="/privacy-policy">
          Privacy Policy
        </Link>
        .
      </>
    ),
  },
  {
    id: "governing-law",
    title: "Governing Law and Dispute Resolution",
    content: (
      <>
        These Terms are governed by and construed in accordance with the laws of
        the country where the services are provided. You and the Company agree
        that we will attempt in good faith to resolve any dispute or claim
        arising out of or in relation to these Terms through negotiations
        between a representative of each of the parties with authority to settle
        the relevant dispute. If the dispute cannot be settled amicably within
        fourteen (14) days from the date on which either Party has served
        written notice on the other of the dispute then the remaining provisions
        of this arbitration clause shall apply.
        <br />
        <br />
        Any dispute, conflict, claim or controversy arising out of or broadly in
        connection with or relating to the services, or these Terms, including
        those relating to its validity, its construction or its enforceability
        (any “Dispute”) shall be exclusively and finally resolved by arbitration
        under the Rules of Arbitration of the International Chamber of Commerce
        (“ICC Arbitration Rules”). The Dispute shall be resolved by one (1)
        arbitrator to be appointed in accordance with the ICC Arbitration Rules.
        The place of arbitration shall be Dubai, UAE. The language of
        arbitration shall be English. The existence and content of the
        arbitration proceedings, including documents and briefs submitted by the
        Parties, correspondence from and to the International Chamber of
        Commerce, correspondence from the arbitrator, and correspondence, orders
        and awards issued by the sole arbitrator, shall remain strictly
        confidential and shall not be disclosed to any third party without the
        express written consent from the other party unless: (i) the disclosure
        to the third party is reasonably required in the context of conducting
        the arbitration proceedings; and (ii) the third party agrees
        unconditionally in writing to be bound by the confidentiality obligation
        stipulated herein.
      </>
    ),
  },
  {
    id: "no-class-action",
    title: "No Class Action",
    content: (
      <>
        You and the Company agree that each may bring claims against the other
        only in your or its individual capacity and not as a plaintiff or class
        member in any purported class or representative proceeding. Further,
        unless both you and the Company agree otherwise in writing, the
        arbitrator may not consolidate more than one person’s claims and may not
        otherwise preside over any form of a representative or class proceeding.
      </>
    ),
  },
  {
    id: "entire-agreement",
    title: "Entire Agreement and Changes to the Terms",
    content: (
      <>
        These Terms along with the payment terms and the Privacy Policy contain
        the entire agreement between you and the Company regarding the use of
        the Platform and supersedes all previous negotiations or agreements both
        orally or in writing regarding the subject matter of these Terms.
        <br />
        You can review the most current version of these Terms at any time on
        our website.
        <br />
        We reserve the right, at our sole discretion and at any time, to update,
        change or replace any part of these Terms by posting updates and changes
        to our website. It is your responsibility to check our website
        periodically for changes. Your continued use of or access to the
        Platform following the posting of any changes to these Terms of Use
        constitutes acceptance of those changes.
        <br />
        By using the Platform, you acknowledge that you have read these Terms,
        understand them and agree to be bound hereby.
      </>
    ),
  },
  {
    id: "contact-information",
    title: "Contact Information",
    content: (
      <ul>
        <li>
          If you have any questions about these Terms, please contact us at{" "}
          <a href="mailto:legal@mohtawa.ai">legal@mohtawa.ai</a>
        </li>
      </ul>
    ),
  },
];
